<template>
  <BCol md="10">
    <div class="text-area p-5 bg-light rounded-custom" ref="text_container">
      <BRow class="mb-3" v-for="sentence in getTextFragmentedBySentences" :key="sentence.id" :id="`marker_${sentence.id}`">
        <BCol md="1" class="position-relative">
          <BRow class="mb-2">
            <BButton @click="scipToSecond(sentence !== undefined && sentence.id in timeTrackerStart ? timeTrackerStart[sentence.id] : '')" variant="white">
              <font-awesome-icon :class="sentence !== undefined && sentence.id in timeTrackerEnd ? 'text-primary' : 'text-secondary'" icon="link" />
            </BButton>
            <div class="position-relative">
              <span :ref="`marker_${sentence.id}`"
                    @click="setStartTimestamp(sentence.id, sentence.sentence)"
                    :class="sentence !== undefined && sentence.timestamp && sentence.timestamp.start ? 'bookmark--active' : null"
                    class="bookmark"
              ></span>
            </div>
          </BRow>
          <BRow class="pl-1">
            <span class="fa-xs" style="color: #8E8AD3" @click="changeTime(sentence.timestamp.start)">
              <input-mask
                  v-if="sentence !== undefined && sentence.timestamp"
                  @input="updateExistTrackerTime(sentence.id, 'start')"
                  type="text"
                  class="time-edit-field"
                  mask="99:99:99"
                  v-model="timeTrackerStart[sentence.id]"
              ></input-mask>
            </span>
          </BRow>
        </BCol>
        <BCol md="10">
          <span v-html="sentence.sentence"></span>
        </BCol>
        <BCol md="1" class="position-relative">
          <BRow class="mb-2">
            <BButton @click="scipToSecond(sentence !== undefined && sentence.id in timeTrackerEnd ? timeTrackerEnd[sentence.id] : '')" variant="white">
              <font-awesome-icon :class="sentence !== undefined && sentence.id in timeTrackerEnd ? 'text-primary' : 'text-secondary'" icon="link" />
            </BButton>
            <div class="position-relative">
              <span @click="setFinishTimestamp(sentence.id, sentence.sentence)"
                    :class="sentence !== undefined && sentence.timestamp && sentence.timestamp.finish ? 'bookmark--active' : null"
                    class="bookmark"
              ></span>
            </div>
          </BRow>
          <BRow class="pl-1">
            <span class="fa-xs" style="color: #8E8AD3">
              <input-mask
                  v-if="sentence !== undefined && sentence.timestamp"
                  @input="updateExistTrackerTime(sentence.id, 'end')"
                  type="text"
                  mask="99:99:99"
                  class="time-edit-field"
                  :class="{'time-edit-field-empty': !timeTrackerEnd[sentence.id]}"
                  v-model="timeTrackerEnd[sentence.id]"
              ></input-mask>

            </span>
          </BRow>
        </BCol>
      </BRow>
    </div>
  </BCol>
</template>

<script>
import * as chapterActions from "../../../../store/modules/Chapter/types/actions";
import { eventBus } from "../../../../app";
import { mapActions } from "vuex";
import Amplitude from "amplitudejs";
import moment from "moment";
import _ from 'lodash';

export default {
  name: "BookContent",
  props: {
    currentChapter: Object
  },
  computed: {
    getIsAllParagraphChecked() {
      return !_.find(this.getTextFragmentedBySentences, obj => obj.timestamp === undefined);
    },
    getTextFragmentedBySentences() {
      if (this.currentChapter) {
        let sentences = _.reduce(_.values(this.currentChapter.sentences),
          (arr, sentence) =>
            arr.concat(
                {
                  id: sentence.id,
                  sentence: sentence.sentence,
                  timestamp: this.currentChapter.sync && _.keys(this.currentChapter.sync).length ? this.currentChapter.sync[sentence.id] : undefined
                }
            ),
          []
        )
        sentences.forEach((sentence) => {
          if(sentence.timestamp !== undefined){
            this.timeTrackerStart[sentence.id] = sentence.timestamp.start;
            this.timeTrackerEnd[sentence.id] = sentence.timestamp.finish;
          }
        })
        return sentences;
      } else {
        return [];
      }
    }
  },
  data: () => ({
    timeTrackerStart: {},
    timeTrackerEnd: {}
  }),
  methods: {
    ...mapActions('Chapter', {
      setSyncForCurrentChapter: chapterActions.SET_SYNC_FOR_CURRENT_CHAPTER,
      updateSyncForCurrentChapter: chapterActions.UPDATE_SYNC_FOR_CURRENT_CHAPTER,
      deleteSyncForCurrentChapter: chapterActions.DELETE_SYNC_FOR_CURRENT_CHAPTER
    }),
    changeTime(currentTime) {
      const timeArr = currentTime.split(":");
      this.editTimeHour = timeArr[0];
      this.editTimeMin = timeArr[1];
      this.editTimeSec = timeArr[2];
      this.showEditTimeForm = true;
    },
    updateExistTrackerTime(sentenceId, type) {
      var myRe = /(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/;
      const value = type === "start" ? this.timeTrackerStart[sentenceId] : this.timeTrackerEnd[sentenceId];
      if (myRe.test(value)) {
          const timestampObj = {
            id: sentenceId,
            chapterId: this.currentChapter.id,
            start: this.timeTrackerStart[sentenceId] || null,
            finish: this.timeTrackerEnd[sentenceId] || null
          }
          this.deleteSyncForCurrentChapter(timestampObj);
          this.setSyncForCurrentChapter(timestampObj);
        //   const beginningTime = moment(this.timeTrackerStart[sentenceId], "HH:mm:ss");
        //   const endTime = moment(this.timeTrackerEnd[sentenceId], "HH:mm:ss");
        //   let haveErrors = false;
        //   if (this.timeTrackerStart[sentenceId] && this.timeTrackerEnd[sentenceId]) {
        //     if (beginningTime > endTime) {
        //       haveErrors  = true;
        //       this.setNotification('error', 'Перевірте інтервали');
        //     }
        //   }
      }
    },
    updateTimestamps(timestampObj) {
      if (this.currentChapter.sync) {
        if (timestampObj.start) {
          this.addStartTimestamp(timestampObj);
        } else if (timestampObj.finish && this.currentChapter.sync[timestampObj.id]) {
          this.addFinishTimestamp(timestampObj);
        } else {
          this.setNotification('danger', 'Проставте початок речення');
        }
      } else {
        if (timestampObj.start) {
          this.setSyncForCurrentChapter(timestampObj);
        } else {
          timestampObj.start = '00:00:00';
          this.setSyncForCurrentChapter(timestampObj);
        }
      }
    },
    setNotification(variant, message) {
      Swal.fire(
          message,
          '',
          variant
      )
    },
    formattedTimestamp(timestamp) {
      timestamp = Number(timestamp);

      const h = Math.floor(timestamp / 3600);
      const m = Math.floor(timestamp % 3600 / 60);
      const s = Math.floor(timestamp % 3600 % 60);

      return `${('0' + h).slice(-2)}:${('0' + m).slice(-2)}:${('0' + s).slice(-2)}`;
    },
    addStartTimestamp(timestampObj) {
      const lastTimestamp = _.maxBy(_.values(this.currentChapter.sync), 'id');
      if (this.currentChapter.sync[timestampObj.id]) {
          this.deleteSyncForCurrentChapter(timestampObj);
          delete this.timeTrackerStart[timestampObj.id];
      } else {
        if (lastTimestamp && !lastTimestamp.finish){
          this.currentChapter.sync[lastTimestamp.id].finish = timestampObj.start;
        }
        this.setSyncForCurrentChapter(timestampObj);
        this.timeTrackerStart[timestampObj.id] = timestampObj.start;
      }
    },
    addFinishTimestamp(timestampObj) {
      if (this.currentChapter.sync[timestampObj.id].finish) {
        this.currentChapter.sync[timestampObj.id].finish = null;
        delete this.timeTrackerEnd[timestampObj.id];
      } else {
        let updateTimestampObj = this.currentChapter.sync[timestampObj.id];
        timestampObj.start = updateTimestampObj.start;
        this.updateSyncForCurrentChapter(timestampObj);
        this.timeTrackerEnd[timestampObj.id] = timestampObj.finish;
      }
    },
    setStartTimestamp(sentenceId) {
      const timestamp = _.floor(Amplitude.getSongPlayedSeconds(), 0);
      this.updateTimestamps({
        id: +sentenceId,
        chapterId: this.currentChapter.id,
        start: this.formattedTimestamp(timestamp),
        finish: null
      });
      //this.timeTrackerStart[sentenceId] = this.formattedTimestamp(timestamp);
      this.isAllParagraphChecked();
    },
    setNextStartTimestamp(sentenceId) {
      const timestamp = _.floor(Amplitude.getSongPlayedSeconds(), 0);
      const currentTime = moment(this.formattedTimestamp(timestamp), "HH:mm:ss").add(1, "seconds");
      this.updateTimestamps({
        id: +sentenceId,
        chapterId: this.currentChapter.id,
        start: currentTime.format('HH:mm:ss'),
        finish: null
      });
      //this.timeTrackerStart[sentenceId] = currentTime.format('HH:mm:ss');
      this.isAllParagraphChecked();
    },

    setFinishTimestamp(sentenceId) {
      const timestamp = _.floor(Amplitude.getSongPlayedSeconds(), 0);
      if (timestamp === 0) {
        delete this.timeTrackerEnd[sentenceId];
      }
      this.updateTimestamps({
        id: +sentenceId,
        chapterId: this.currentChapter.id,
        start: null,
        finish: this.formattedTimestamp(timestamp)
      });
      const firstSentence = _.minBy(_.values(this.getTextFragmentedBySentences), 'id');
      const lastSentence = _.maxBy(_.values(this.getTextFragmentedBySentences), 'id');
      const lastTimestamp = this.currentChapter.sync
          ? _.maxBy(_.values(this.currentChapter.sync), 'id')
          : null;
      let nextSentence = null;

      if (lastTimestamp) {
        if (lastTimestamp.id < lastSentence.id) {
          nextSentence = this.getTextFragmentedBySentences[String(lastTimestamp.id + 1)]
        } else {
          this.setNotification('error', 'Промаркерованi уci речення')
        }
      } else {
        nextSentence = firstSentence
      }
      //this.timeTrackerEnd[sentenceId] = this.formattedTimestamp(timestamp);
      if (nextSentence) {
        this.setNextStartTimestamp(nextSentence.id);
      }
    },
    isAllParagraphChecked() {
      eventBus.$emit('isAllParagraphChecked',
          this.getIsAllParagraphChecked
      )
    },
    scipToSecond(timestamp) {
      const currentAudioIndex = Amplitude.getActiveIndex();
      const timeArr = _.split(timestamp, ':')
      const h = parseInt(timeArr[0],10) * 60 * 60;
      const m = parseInt(timeArr[1],10) * 60;
      const s = parseInt(timeArr[2],10)
      const toSecond = h + m + s;

      Amplitude.skipTo( toSecond, currentAudioIndex );
    },
  },
  created() {
    eventBus.$on(
        'addTimestamp',
      () => {
        const firstSentence = _.minBy(_.values(this.getTextFragmentedBySentences), 'id');
        const lastSentence = _.maxBy(_.values(this.getTextFragmentedBySentences), 'id');
        const lastTimestamp = this.currentChapter.sync
            ? _.maxBy(_.values(this.currentChapter.sync), 'id')
            : null;
        let nextSentence = null;

        if (lastTimestamp) {
          if (lastTimestamp.id < lastSentence.id) {
            nextSentence = this.getTextFragmentedBySentences[String(lastTimestamp.id + 1)]
          } else {
            const timestamp = _.floor(Amplitude.getSongPlayedSeconds(), 0);
            this.timeTrackerEnd[lastSentence.id] = this.formattedTimestamp(timestamp);
            this.updateTimestamps({
              id: lastSentence.id,
              chapterId: this.currentChapter.id,
              start: null,
              finish: this.formattedTimestamp(timestamp)
            });
            this.setNotification('error', 'Промаркерованi уci речення')
            // console.log("after", this.timeTrackerEnd);
          }
        } else {
          nextSentence = firstSentence
        }

        if (nextSentence) {
          const parent = this.$refs['text_container'];
          var elm = document.getElementById(`marker_${nextSentence.id}`);
          if (elm) {
            parent.scrollTo(0, elm.offsetTop - 46);
          }
          if (lastTimestamp && !lastTimestamp.finish) {
            this.setFinishTimestamp(lastTimestamp.id);
          } else {
            this.setStartTimestamp(nextSentence.id);
          }
        }
      }
    );
  }
}
</script>

<style scoped>
.time-edit-field-empty {
  color: #FFF !important;
}
.time-edit-field {
  border: none;
  background: transparent;
  color: rgb(142, 138, 211);
}
.text-area {
  overflow-y: auto;
  height: 50vh;
}
.text-area::-webkit-scrollbar {
  left: 10px;
  width: 10px;
  background-color: #f9f9fd;
}

.text-area::-webkit-scrollbar-thumb {
  left: 10px;
  border-radius: 10px;
  background-color: #808080;
}
.bookmark{
  background: #C4C4C4;
  content: "";
  position: absolute;
  height: 26px;
  width: 20px;
  left: 20px;
}
.bookmark:hover {
  background: #8E8AD3 !important;
}
.bookmark--active {
  background: #605CA8 !important;
}
.bookmark::before {
  background: #f8f9fa;
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  top: 20px;
  transform: rotate(45deg)
}
.rounded-custom {
   border-radius: 2rem;
 }
</style>